import React from 'react';
import IconChatEmpty from './IconChatEmpty';

interface EmptyChatStateProps {
  greeting?: string;
  hint?: string;
  className?: string;
}

const EmptyChatState: React.FC<EmptyChatStateProps> = ({
  greeting,
  hint = 'Write something awesome…',
  className,
}) => {
  const finalGreeting = greeting ?? defaultGreetingForHour(new Date().getHours());
  return (
    <div
      className={`flex flex-1 flex-col items-center justify-center gap-2 px-4 ${className ?? ''}`}
    >
      <IconChatEmpty className="w-[120px] h-[120px] text-text-tertiary" />
      <p className="text-base font-semibold text-text-tertiary">{finalGreeting}</p>
      <p className="text-sm text-text-tertiary">{hint}</p>
    </div>
  );
};

function defaultGreetingForHour(h: number): string {
  if (h < 5) return 'Good night!';
  if (h < 12) return 'Good morning!';
  if (h < 18) return 'Good afternoon!';
  return 'Good evening!';
}

export default EmptyChatState;
